import * as React from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    const element = document.getElementsByTagName('html')[0];

    if (element) {
      setTimeout(() => {
        element.scroll(0, 0);
      }, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
